import React from 'react';
import { LoginView } from './LoginView';
import { RedirectToIdp } from './RedirectToIdp';
import { useBuildVars, useSiteConfig } from '../config';
import { LoginViewX4EC } from '../x4ec/auth/LoginViewX4EC';

export function Login() {
  const siteConfig = useSiteConfig();
  const { appId } = useBuildVars();

  if (siteConfig.idpLogin) {
    return <RedirectToIdp />;
  } else {
    return appId === 'x4ec' ? <LoginViewX4EC /> : <LoginView />;
  }
}
